import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Badge } from "../ui/badge";
import { formatDateTimeIST } from "../../utils/dateUtils";
import { getStatusIcon } from "./nocUtils";
import { FileText, Brain } from "lucide-react";

export const TestDetailDialog = ({ selectedTest, setSelectedTest, testDetail }) => {
  return (
    <Dialog open={!!selectedTest} onOpenChange={() => setSelectedTest(null)}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto" data-testid="test-detail-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5" />
            Test Detail: {testDetail?.serial_number || "No Serial Number"}
          </DialogTitle>
        </DialogHeader>

        {testDetail && (
          <div className="space-y-4">
            {/* Test Summary */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="p-3 bg-muted rounded-lg">
                <p className="text-xs text-muted-foreground">Product</p>
                <p className="font-medium">{testDetail.product_name}</p>
              </div>
              <div className="p-3 bg-muted rounded-lg">
                <p className="text-xs text-muted-foreground">Tester</p>
                <p className="font-medium">{testDetail.tester_name}</p>
              </div>
              <div className="p-3 bg-muted rounded-lg">
                <p className="text-xs text-muted-foreground">Status</p>
                <Badge variant={testDetail.status === "passed" ? "default" : "destructive"}>
                  {testDetail.status}
                </Badge>
              </div>
              <div className="p-3 bg-muted rounded-lg">
                <p className="text-xs text-muted-foreground">Progress</p>
                <p className="font-medium">{testDetail.current_step}/{testDetail.total_steps} steps</p>
              </div>
            </div>

            {/* Step Results */}
            <div className="space-y-2">
              <h4 className="font-medium">Step-by-Step Results</h4>
              {testDetail.step_results?.map((sr) => (
                <div
                  key={sr.step_id}
                  className={`p-3 rounded-lg border ${
                    sr.status === "pass" ? "bg-emerald-500/5 border-emerald-500/20" :
                    sr.status === "fail" ? "bg-red-500/5 border-red-500/20" :
                    "bg-amber-500/5 border-amber-500/20"
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex items-center gap-3">
                      {getStatusIcon(sr.status)}
                      <div>
                        <p className="font-medium">Step {sr.step_number}: {sr.step_name}</p>
                        <div className="flex items-center gap-2 mt-1">
                          <Badge variant="outline" className="text-xs">{sr.cv_task}</Badge>
                          <Badge variant="outline" className="text-xs">{sr.phase_name || sr.phase}</Badge>
                        </div>
                        {sr.pass_criteria && (
                          <p className="text-xs text-muted-foreground mt-1">
                            Criteria: {sr.pass_criteria}
                          </p>
                        )}
                        {sr.ai_analysis && (
                          <div className="mt-2 p-2 bg-blue-500/10 rounded text-xs">
                            <span className="font-medium text-blue-600">AI Analysis:</span>
                            <p>{sr.ai_analysis.result} - Confidence: {sr.ai_analysis.confidence}%</p>
                            {sr.ai_analysis.details && <p className="text-muted-foreground">{sr.ai_analysis.details}</p>}
                          </div>
                        )}
                      </div>
                    </div>
                    <p className="text-xs text-muted-foreground">{formatDateTimeIST(sr.verified_at)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
